const searchFilters = document.querySelector('.c-search-filters');

const checkWindowWidth = () => {
    const currentWidth = window.innerWidth;

    // force filters accordion open if on desktop
    if (currentWidth >= 1024) {
        const accordionItem = searchFilters.querySelector('.accordion-item');
        const accordionContent = searchFilters.querySelector('.accordion-content');
        accordionItem.classList.add('open');
        accordionContent.style.display = 'block';
    }
};

if (searchFilters) {
    checkWindowWidth();
    window.addEventListener('resize', checkWindowWidth);
}



// WEBPACK FOOTER //
// ./src/components/search-filters/c-search-filters.js